module.exports = __webpack_public_path__ + "img/csr_121222_A.a97ccce0.jpg";